var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
import { __awaiter, __decorate, __metadata } from "tslib";
import { ErrorFormPayload } from '@/core/types/misc/ErrorFormPayload';
import { ErrorPayload } from '@/core/types/misc/ErrorPayload';
import { ErrorResponse } from '@/core/types/misc/ErrorResponse';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { Actions, Mutations } from '../enums/ErrorHandleEnum';
import { swalAlertError, swalAlertErrorBulk } from '@/core/helpers/sweet-alert';
let ErrorHandleModule = class ErrorHandleModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isError = false;
        this.errorResponse = {};
        this.errorPages = {};
        // state for input error messages
        this.isFromSubmitError = false;
        this.formSubmitErrorMessages = [];
    }
    get getIsError() {
        return this.isError;
    }
    get getErrorResponse() {
        return this.errorResponse;
    }
    get getErrorPages() {
        return this.errorPages;
    }
    [_a = Mutations.SET_IS_ERROR](payload) {
        this.isError = payload;
    }
    [_b = Mutations.SET_ERROR_RESPONSE](payload) {
        this.errorResponse = payload;
    }
    [_c = Mutations.SET_ERROR_PAGES](payload) {
        this.errorPages[payload] = {};
    }
    [_d = Mutations.SET_ERROR_ON_PAGES](payload) {
        this.errorPages[payload.page][payload.name] = {
            message: payload.message,
            status: typeof payload.status !== undefined ? payload.status : ''
        };
    }
    [_e = Actions.UPDATE_ERROR_TO_PAGE](payload) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ERROR_ON_PAGES, payload);
            if (payload.type === 'unhandledError' &&
                (typeof payload.status == 'undefined' || payload.status)) {
                this.context.dispatch(Actions.TRIGGER_SWAL_ERROR_RESPONSE, payload.message);
            }
            else if (payload.type === 'unhandledErrorBulk' &&
                (typeof payload.status == 'undefined' || payload.status)) {
                this.context.dispatch(Actions.TRIGGER_SWAL_ERROR_BULK_RESPONSE, payload.message);
            }
        });
    }
    [_f = Actions.UPDATE_ERROR](payload) {
        return __awaiter(this, void 0, void 0, function* () {
            // reset current error state
            yield this.context.dispatch(Actions.RESET_ERROR);
            // update error message
            this.context.commit(Mutations.SET_IS_ERROR, payload.status);
            this.context.commit(Mutations.SET_ERROR_RESPONSE, payload.errorResponse);
            // call error modal showing error message
            this.context.dispatch(Actions.TRIGGER_SWAL_ERROR_RESPONSE, this.getErrorResponse.message);
        });
    }
    [_g = Actions.TRIGGER_SWAL_ERROR_RESPONSE](payload) {
        swalAlertError(payload, 'OK');
    }
    [_h = Actions.TRIGGER_SWAL_ERROR_BULK_RESPONSE](payload) {
        swalAlertErrorBulk(payload);
    }
    [_j = Actions.RESET_ERROR]() {
        this.context.commit(Mutations.SET_IS_ERROR, false);
        this.context.commit(Mutations.SET_ERROR_RESPONSE, {});
    }
    get getformSubmitErrorMessages() {
        return this.formSubmitErrorMessages;
    }
    get getIsFromSubmitError() {
        return this.isFromSubmitError;
    }
    [_k = Mutations.SET_FORM_INPUT_ERROR_MESSAGES](payload) {
        this.formSubmitErrorMessages = payload;
    }
    [_l = Mutations.SET_IS_FORM_INPUT_ERROR](payload) {
        this.isFromSubmitError = payload;
    }
    [_m = Actions.UPDATE_FORM_INPUT_ERROR](payload) {
        this.context.dispatch(Actions.RESET_FORM_INPUT_ERROR);
        this.context.commit(Mutations.SET_IS_FORM_INPUT_ERROR, payload.status);
        this.context.commit(Mutations.SET_FORM_INPUT_ERROR_MESSAGES, payload.errorMessages);
    }
    [_o = Actions.RESET_FORM_INPUT_ERROR]() {
        this.context.commit(Mutations.SET_IS_FORM_INPUT_ERROR, false);
        this.context.commit(Mutations.SET_FORM_INPUT_ERROR_MESSAGES, []);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_p = typeof ErrorResponse !== "undefined" && ErrorResponse) === "function" ? _p : Object]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _d, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], ErrorHandleModule.prototype, _e, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_q = typeof ErrorPayload !== "undefined" && ErrorPayload) === "function" ? _q : Object]),
    __metadata("design:returntype", Promise)
], ErrorHandleModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_r = typeof ErrorFormPayload !== "undefined" && ErrorFormPayload) === "function" ? _r : Object]),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ErrorHandleModule.prototype, _o, null);
ErrorHandleModule = __decorate([
    Module
], ErrorHandleModule);
export default ErrorHandleModule;
